"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Actions = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _globals = require("../../../lib/constants/globals");
var _styles = require("../styles");
var _Warning = require("./Warning");
var _BookingButton = require("./BookingButton");
var _ViewAvailabilityButton = require("./ViewAvailabilityButton");
var _BookingInfo = require("./BookingInfo");
const Actions = _ref => {
  let {
    provider,
    modalDisplay,
    bookingCallback,
    shouldDisplayAvailability,
    slotsStatus,
    track,
    config,
    isBookingDisabled,
    showWarning,
    bookingWarning,
    onClickShowAvailability,
    locations,
    summaryUrl
  } = _ref;
  const showWaitTimeLink = (0, _get2.default)(config, 'darkship_feature_flags.show_wait_time_link', false) && provider.external_wait_time_url;
  return /*#__PURE__*/_react.default.createElement(_styles.ActionsContainer, {
    showWarning: showWarning,
    "data-testid": "provider-tile-booking-actions"
  }, showWarning && /*#__PURE__*/_react.default.createElement(_Warning.Warning, {
    bookingWarning: bookingWarning
  }), showWaitTimeLink && /*#__PURE__*/_react.default.createElement(_styles.StyledButtonLink, {
    href: `${summaryUrl}#EstimatedWaitTimeHeader`,
    mode: "secondary"
  }, "View Estimated Wait Time"), /*#__PURE__*/_react.default.createElement(_BookingButton.BookingButton, {
    provider: provider,
    modalDisplay: modalDisplay,
    bookingCallback: bookingCallback,
    track: track,
    disabled: isBookingDisabled
  }), slotsStatus !== _globals.SLOTS_SUCCESS_STATUS && /*#__PURE__*/_react.default.createElement(_ViewAvailabilityButton.ViewAvailabilityButton, {
    providerId: provider.id,
    onClickShowAvailability: onClickShowAvailability,
    shouldDisplayAvailability: shouldDisplayAvailability,
    locations: locations,
    disabled: slotsStatus === _globals.SLOTS_LOADING_STATUS,
    track: track
  }), /*#__PURE__*/_react.default.createElement(_BookingInfo.BookingInfo, {
    provider: provider,
    shouldDisplayAvailability: shouldDisplayAvailability,
    slotsStatus: slotsStatus,
    config: config
  }));
};
exports.Actions = Actions;
Actions.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Actions"
};